import BaseRoute from 'seshy/routes/base';
import { service } from '@ember/service';
import { action } from '@ember/object';

export default class AuthenticatedTeamsShowProjectsShowProjectFilesRoute extends BaseRoute {}
